// extracted by mini-css-extract-plugin
export default {"npsWrapper":"NpsSurveyCard_npsWrapper__GAnrA","ratingBox":"NpsSurveyCard_ratingBox__9xLhi"};